module.exports = __webpack_public_path__ + "static/media/bicycle.d38cc5c6.svg";